/* eslint-disable react-hooks/exhaustive-deps */
import { lazy, Suspense, useEffect } from "react";
import { useRoutes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Themeroutes from "./routes/Router";
import Loadable from "./layouts/loader/Loadable";
import { ToastContainer } from "react-toastify";
import useIdleLogout from "./middleware/useIdleLogout";

const Loader = Loadable(lazy(() => import("./layouts/loader/Loader")));


const App = () => {
  const navigate = useNavigate();
  useIdleLogout()
  // const location = useLocation();
  // const dispatch = useDispatch();
  const direction = useSelector((state) => state.customizer.isRTL);
  const isMode = useSelector((state) => state.customizer.isDark);
  // const { user: currentUser } = useSelector((state) => state.user);
  // const { token: Usertoken } = useSelector((state) => state.user);
  // const { user: currentUser } = useSelector((state) => state.user);
  window.history.pushState(null, null, window.location.href);
  window.onpopstate = () => {
    navigate(1);
  };
  // useEffect(() => {
  //   dispatch(fetchUserData({ Usertoken, currentUser }));
  // }, [Usertoken]);
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes();
      if (hour === 0 && minute === 0) {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        sessionStorage.clear();
        window.location.assign('/login')
      }
    }, 30 * 1000);
    
    return () => clearInterval(interval);
  }, []);


  const routing = useRoutes(Themeroutes);

  // useEffect(() => {
  //   // Event listener to handle the beforeunload event
  //   const handleBeforeUnload = (event) => {
  //     if (event.type === 'beforeunload') {
  //       // Perform any cleanup tasks, like clearing location storage
  //       sessionStorage.clear();
  //       // The message below is optional, but it will prompt the user with a confirmation dialog
  //       event.returnValue = 'Are you sure you want to leave?';
  //     }
  //   };
  //   // Add the event listener when the component mounts
  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   // Remove the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);

  return (
    <Suspense fallback={<Loader />}>
        <ToastContainer
          bodyClassName="toastBody"
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div
          className={`${direction ? "rtl" : "ltr"} ${isMode ? "dark" : ""}`}
          dir={direction ? "rtl" : "ltr"}
        >
          {routing}
        </div>
    </Suspense>
  );
};

export default App;
